import { apiUrls } from '../constants/apis.js';
export function getApiUrl(envOrApiBaseUrl = 'mainnet') {
    return apiUrls[envOrApiBaseUrl] ?? envOrApiBaseUrl;
}
//# sourceMappingURL=getApiUrl.js.map